<div class="modal fade" id="messageBoxModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ title }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                {{ message }}
            </div>
            <div class="modal-footer">
                <button mat-stroked-button color="primary" type="button" (click)="onButtonClick('ok')"
                    data-bs-dismiss="modal">
                    {{ okLable }}
                </button>

                <button mat-stroked-button color="warn" type="button" (click)="onButtonClick('cancel')"
                    data-bs-dismiss="modal">
                    {{ cancelLable }}
                </button>
            </div>
        </div>
    </div>
</div>